import { render, staticRenderFns } from "./ResultTimeliness.vue?vue&type=template&id=c4f2ccd8&scoped=true&"
import script from "./ResultTimeliness.vue?vue&type=script&lang=ts&"
export * from "./ResultTimeliness.vue?vue&type=script&lang=ts&"
import style0 from "./ResultTimeliness.vue?vue&type=style&index=0&id=c4f2ccd8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f2ccd8",
  null
  
)

export default component.exports